module.exports = __webpack_public_path__ + "static/a-xx-116-art-e5e1312aeed450c1f8d807317bf6e9fc.jpg";